'use strict';

angular.module('cgmemApp')
	.controller('ActivateEnterCtrl', function ($state, $stateParams, $log, Activate) {
		this.alert = '';
		this.pword1 = this.pword2 = '';

		this.username = $stateParams.username;
		this.newActivation = !!$stateParams.new;

		if(!$stateParams.username || !$stateParams.token)
			this.alert = "Link is not valid.";
		else
			this.linkValid = true;

		this.valid = function (s) {
			return (s.length > 6 && s.replace(/[^0-9]/g, "").length && s.replace(/[^a-z]/g, ""));
		}

		this.submit = function () {
			//$state.go('^.wait');
			if (this.pword1.length >= 6 && this.pword1.replace(/[^0-9]/g, "").length
				&& this.pword1.replace(/[^a-z]/g, "") && (this.pword1 == this.pword2)) {
				this.alert = false;
				Activate.set(!!$stateParams.new, $stateParams.username, $stateParams.token, this.pword1);
				$state.go('^.wait');
			} else {
				if (this.pword1 == this.pword2)
					this.alert = "Passwords must be at least 6 characters, contain a number and a lowercase letter."
				else
					this.alert = "Passwords must match";
				this.pword1 = this.pword2 = '';
			}
		}
	})
	.controller('ActivateWaitCtrl', function ($state, $stateParams, Activate) {
		Activate.get()
		.then(function() {
			$state.go('^.success');
		})
		.catch(function(err) {
			$state.go('^.fail');
		});
	})
	.controller('ActivateSuccessFailCtrl', function (Activate) {
		this.newActivation = Activate.newActivation();
	});
;
